
////////////////////////////////////
// M074 article overview
function initArticleOverview() {

    if ($(".article-overview").length > 0) {

        $(".article-overview__nav-list").on("touchstart", dragMouseDown);
        $(".article-overview__nav-list").on("mousedown", dragMouseDown);


        var hash = window.location.hash.substring(1);
        if(hash && hash == "articleOverviewAnchor"){
            scrollToArticleOverview();
            setTimeout(scrollToArticleOverview, 500);
            setTimeout(scrollToArticleOverview, 1000);
        }
    }
}

function scrollToArticleOverview(){
    if($("#articleOverviewAnchor").length > 0){
        var offset = $("#articleOverviewAnchor").offset().top;
        $('html, body').animate({
            scrollTop: offset
        }, 250);
    }
}

function updateArticleOverview() {
    //console.log("updatearticle-overview");
    if ($(".article-overview").length > 0) {

        $(".article-overview").each(function () {
            $("#articleOverviewNavList").css("margin-left", 0);
        });

        $(".article-overview__teaser-headline").each(function(){
            var $copy = $(this).siblings(".article-overview__teaser-copy");
            $copy.removeClass("article-overview__teaser-copy--lc3");
            if($(this).height() > 24){
                $copy.addClass("article-overview__teaser-copy--lc3");
            }
        });
    }
}